<!-- <script>
import EventHead from '@/common/components/eventHead/EventHead';
import normalCard from '@/common/components/normal/NormalCard';
export default {
  components: {
    EventHead,
    normalCard
  },
  data() {
    return {
      merchantList: [
        {
          id: 1,
          stadiumName: '万象足球公园',
          createTime: '2025-05-23 15:34:21',
          username: '张三',
          phone: '13812345678',
          totalAmount: '123456.00',
          version: '基础版',
          commissionRate: 3,
          status: '审核中'
        },
        {
          id: 2,
          stadiumName: '城阳足球公园',
          createTime: '2025-05-23 15:34:22',
          username: '李四',
          phone: '13812345678',
          totalAmount: '123456.00',
          version: '会员版',
          commissionRate: 2,
          status: '已入驻'
        }
      ],
      adjustDialogVisible: false,
      currentCommission: 0,
      selectedMerchant: null
    }
  },
  methods: {
    // 显示调整弹窗
    showAdjustDialog(row) {
      this.selectedMerchant = row
      this.currentCommission = row.commissionRate
      this.adjustDialogVisible = true
    },

    // 确认调整佣金
    confirmAdjust() {
      this.$confirm('确定要调整佣金比例吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.selectedMerchant.commissionRate = this.currentCommission
        this.adjustDialogVisible = false
        this.$message.success('调整成功')
      })
    },

    // 同意入驻
    handleApprove(row) {
      this.$confirm('确定同意该商户入驻吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.status = '已入驻'
        this.$message.success('操作成功')
      })
    },

    // 删除商户
    handleDelete(row) {
      this.$confirm('确定要删除该商户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.merchantList = this.merchantList.filter(item => item.id !== row.id)
        this.$message.success('删除成功')
      })
    }
  }
}
</script> -->

<template>
  <div>
    <event-head></event-head>
    <!-- 商户列表卡片 -->
    <normal-card title="入驻商户" class="mt-5">
      <el-table :data="merchantList" style="width: 100%" :header-cell-style="{
        color: '#fff',
        fontSize: '14px',
        height: '40px',
        width: '100%',
      }">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="stadiumName" label="机构名称" align="center"></el-table-column>
        <el-table-column prop="createTime" label="入驻时间" align="center"></el-table-column>
        <el-table-column prop="type" label="类型" align="center"></el-table-column>
        <el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
        <el-table-column prop="address" label="地址" align="center"></el-table-column>
        <el-table-column prop="totalAmount" label="交易总额" align="center">
          <template slot-scope="scope">¥{{ scope.row.totalAmount }}</template>
        </el-table-column>
        <el-table-column prop="commission" label="平台佣金" align="center">
          <template slot-scope="scope">¥{{ scope.row.commission }}</template>
        </el-table-column>
        <el-table-column prop="SaaS" label="SaaS订阅" align="center">
          <template slot-scope="scope">¥{{ scope.row.SaaS }}</template>
        </el-table-column>
        <!-- <el-table-column prop="version" label="系统版本" align="center"></el-table-column> -->
        <el-table-column label="佣金比例" align="center">
          <template slot-scope="scope">
            {{ scope.row.commissionRate }}%
            <el-button type="text" @click="showAdjustDialog(scope.row)">调整</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '已入驻' ? 'success' : 'warning'">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="text" :disabled="scope.row.status === '已入驻'"
              @click="handleApprove(scope.row)">同意入驻</el-button>
            <el-button type="text" style="color: #ff4d4f" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </normal-card>

    <!-- 调整佣金弹窗 -->
    <el-dialog title="调整佣金比例" :visible.sync="adjustDialogVisible" width="30%">
      <el-form label-width="120px">
        <el-form-item label="佣金比例">
          <el-input-number v-model="currentCommission" :min="1" :max="10" controls-position="right"></el-input-number> %
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="adjustDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAdjust">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EventHead from '@/common/components/eventHead/EventHead';
import normalCard from '@/common/components/normal/NormalCard';
export default {
  components: {
    EventHead,
    normalCard
  },
  data() {
    return {
      merchantList: [
        {
          id: 1,
          stadiumName: '21号足球公园',
          createTime: '2025/07/01',
          type: '球场',
          address: '合肥市高新区中安创谷产业园A1栋503',
          phone: '15856921900',
          totalAmount: '¥376,521.50',
          commission: '¥18,826.08',
          SaaS: '¥7,600.00',
          version: '基础版',
          commissionRate: 3,
          status: '审核中'
        },
        // {
        //   id: 2,
        //   stadiumName: '城阳足球公园',
        //   createTime: '2025-05-23 15:34:22',
        //   type: '李四',
        //   phone: '13812345678',
        //   address: '合肥市高新区中安创谷产业园A1栋503',
        //   totalAmount: '376,521.50',
        //   commission: '18,826.08',
        //   SaaS: '7,600.00',
        //   version: '会员版',
        //   commissionRate: 2,
        //   status: '已入驻'
        // }
      ],
      adjustDialogVisible: false,
      currentCommission: 0,
      selectedMerchant: null
    }
  },
  methods: {
    // 显示调整弹窗
    showAdjustDialog(row) {
      this.selectedMerchant = row
      this.currentCommission = row.commissionRate
      this.adjustDialogVisible = true
    },

    // 确认调整佣金
    confirmAdjust() {
      this.$confirm('确定要调整佣金比例吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.selectedMerchant.commissionRate = this.currentCommission
        this.adjustDialogVisible = false
        this.$message.success('调整成功')
      })
    },

    // 同意入驻
    handleApprove(row) {
      this.$confirm('确定同意该商户入驻吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.status = '已入驻'
        this.$message.success('操作成功')
      })
    },

    // 删除商户
    handleDelete(row) {
      this.$confirm('确定要删除该商户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.merchantList = this.merchantList.filter(item => item.id !== row.id)
        this.$message.success('删除成功')
      })
    }
  }
}
</script>

<style scoped>
.el-table {
  color: #ffffff;
}

.el-table /deep/ th {
  background-color: #f5f7fa00;
}

.el-button--text {
  padding: 0;
}
</style>